import React from 'react';
import IModal from "../../../../../components/Admin/Modal/IModal";
import {Button, Grid, Typography} from "@mui/material";
import {successMessage} from "../../../../../tools/messages";

const ModalDeleteCustomer = ({open, close, invalidateData = undefined, customItem}) => {

    const deleteItemById = async () => {
        try {
            customItem()
            // successMessage(res.data.msg)
            successMessage('با موفقیت انجام شد');
            await invalidateData();
        } catch (e) {

        }
        close();
    }

    return (
        <IModal width={300} showClose open={open} handleClose={close}>

            <Grid>
                <Typography>
                    آیا میخواهید این عکس را حذف کنید؟
                </Typography>
                <Grid sx={{mx: 2, my: 3}} display={"flex"} justifyContent={"space-around"}>
                    <Button color={"success"} onClick={deleteItemById}
                            sx={{background: "#592EA9", borderRadius: "18px", padding: "8px 40px"}}
                            variant={'contained'}>بله</Button>

                    <Button sx={{background: "#592EA9", borderRadius: "18px", padding: "8px 40px"}} onClick={close}
                            variant={'contained'}
                            color={'error'}>خیر</Button>

                </Grid>
            </Grid>

        </IModal>
    );
};

export default ModalDeleteCustomer;